module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAABCAYAAAAVSWrbAAABCElEQVQoU0WPO1IDUQwEZyQtuICABIqUm/o+PgV38B1IKBxA8VlLGkrrgJeMXvcoEAFAEg+Hg51OJzsef+35+cmqfuzz2px1tqvFfPmmryt9DfridHd4nuGQh9lkRW1pEaowW1yqSHWYhcs6HIxSB8QAGOT0FaS5oIA6SHcNrw46XdUBM8N40Aj4tgeZRJc4zmAwChw/92xdiuKgyxu/3Uvon2nqAtQkNQOABtjDLjPq8u+WUAKKRFHDN5fDaahJQElaTk734qtAS4clqSwqUZY2l65Z089h7PRWgZ5kZNVvVaM8VLQll0TltYpfP73u7mq3ot750Tf3j4XXtwZuG3ho4KX3+73+ACdvswMjQvMbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/crm/renzheng/hr.png
// module id = vBZ1
// module chunks = 2